import { Slider } from '@wajeez-web/components/ui';
import { Skeleton } from 'antd';

import { MediaHelpers } from '@wajeez-web/core/api';
import {
  BaseComponentProps,
  useComponentData,
  useSkeletonHelper,
} from '../helpers/contentHooks';
import { ClickableComponentLayout } from '../layouts/ClickableComponentLayout';

export interface LargeRectangleGridParameters {
  title: string | null;
}

export function LargeRectangleGrid({
  component,
  context,
  isLastSibling,
}: BaseComponentProps) {
  const { getParameterValue, contents, contentsRequestStatus } =
    useComponentData<LargeRectangleGridParameters>(component, context);

  const { isActive } = useSkeletonHelper(
    contentsRequestStatus,
    contents?.length ? true : false
  );

  return contentsRequestStatus !== 'loading' &&
    contentsRequestStatus !== 'failed' &&
    contents?.length ? (
    <div className="space-y-[17px]">
      <div className="flex justify-between px-4">
        <div className=" font-bold text-[20px]">
          {getParameterValue('title')}
        </div>
      </div>
      <div>
        <div
          className={`w-full sm:px-[36px] ${
            !isLastSibling && 'border-b-[0.5px]'
          } border-[#C6C6C8] dark:border-dark-divider`}
        >
          <Slider customStyle="pb-10 px-2">
            {contents?.map((content, i) => (
              <LargeRectangleGridItem
                key={content.id}
                component={{ ...component?.itemTemplate, uniqueId: i }}
                context={content}
                index={i}
              />
            ))}
          </Slider>
        </div>
      </div>
    </div>
  ) : (contentsRequestStatus === 'loading' ||
      contentsRequestStatus === 'failed') &&
    !contents?.length ? (
    <LargeRectangleGridSkeleton
      isLastSibling={isLastSibling}
      isActive={isActive}
    />
  ) : null;
}

const LargeRectangleGridSkeleton = ({
  isLastSibling,
  isActive = true,
}: {
  isLastSibling: boolean | 0 | undefined;
  isActive?: boolean;
}) => {
  return (
    <div className="w-full pr-2">
      <Skeleton active={isActive} paragraph={{ rows: 0 }} className="pr-2" />
      <div
        className={`w-full sm:px-[36px] ${
          !isLastSibling && 'border-b-[0.5px]'
        } border-[#C6C6C8] dark:border-dark-divider`}
      >
        <Slider>
          {Array.from({ length: 10 }).map((_, i) => {
            return (
              <div key={i} className="w-[249px]">
                <Skeleton.Node
                  active={isActive}
                  className="!w-[249px] !h-[332px]"
                >
                  <div />
                </Skeleton.Node>
                <Skeleton
                  active={isActive}
                  paragraph={{ rows: 0 }}
                  className="mt-1"
                />
              </div>
            );
          })}
        </Slider>
      </div>
    </div>
  );
};

export interface LargeRectangleGridItemProps extends BaseComponentProps {
  index: number;
}
export interface LargeRectangleGridItemParameters {
  image: string | null;
}

export const LargeRectangleGridItem = ({
  component,
  context,
  index,
}: LargeRectangleGridItemProps) => {
  const { getParameterValue, content } =
    useComponentData<LargeRectangleGridItemParameters>(component, context);

  return (
    <ClickableComponentLayout content={content}>
      <div className="flex-col w-[249px] items-start justify-start space-y-[4px]">
        <div
          style={{
            backgroundImage:
              'url(' +
              MediaHelpers.getPublicMediaById(getParameterValue('image')) +
              ')',
          }}
          className={` h-[332px] w-[249px]  border  rounded-[10px]   bg-cover bg-center bg-no-repeat mb-[4px] flex flex-col justify-end px-[13px] relative `}
        >
          <div className=" font-extrabold  text-[125px] text-white/80 absolute right-[13px] -bottom-8">
            {index + 1}
          </div>
        </div>
        <div className="text-[16px]">{content?.title}</div>
      </div>
    </ClickableComponentLayout>
  );
};
